module.exports = __webpack_public_path__ + "static/media/logo.cb8ce072.png";